import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addLocale(en);

import React, { useEffect, useState } from "react";
import ReactTimeAgo from "react-time-ago";

import StatsPalette from "../statsPalette/statsPalette.component";
import ChartPalette from "../chartPalette/chartPalette.component";
import RightImpersonationFormWrapper from "../rightImpersonationFormWrapper/rightImpersonationFormWrapper.component";
import useAppContext from "../../../hooks/useAppContext";

import { StyledWrapper } from "./dashboardLayout.style";

const DashboardLayout = () => {
  const { axios } = useAppContext();
  const [data, setData] = useState({});

  useEffect(() => {
    axios
      .get("/admin/stats", {})
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <StyledWrapper>
      <div className="page-timestamp">
        {data.updatedAt ? (
          <>
            Last updated about{" "}
            <ReactTimeAgo date={data.updatedAtTimestamp} locale="en-US" />
          </>
        ) : (
          `\u00A0`
        )}
      </div>
      <RightImpersonationFormWrapper>
        <StatsPalette data={data} />
      </RightImpersonationFormWrapper>
      <ChartPalette />
    </StyledWrapper>
  );
};

export default DashboardLayout;
